/**
 * Navigation helper - For User Pilot tooltips
 *
 * This is a singleton that provides a navigate function that can be used to navigate to a new route from the Userpilot tooltips.
 *
 * It is used to navigate to a new route when the user clicks the "Going to Assistant"(or other buttons) in the Userpilot tooltip.
 *
 * It is initialized in the main.tsx file with the router's navigate function.
 *
 * This can be used to navigate to any route in the app.
 */

export const upNavigationHelper = (() => {
  let navigateFunction: ((path: string) => void) | null = null

  const navigate = (path: string) => {
    if (!navigateFunction) {
      console.warn('Navigation function not initialized. Path requested:', path)
      return
    }
    navigateFunction(path)
  }

  const initialize = (navFunction: (path: string) => void) => {
    navigateFunction = navFunction
  }

  return {
    navigate,
    initialize,
  }
})()

// Safely initialize the window function
const initializeWindowNavigation = () => {
  if (typeof window !== 'undefined') {
    window.goToNewAssistantChat = () => {
      // Navigate to matters table - user must select a matter to start a chat
      upNavigationHelper.navigate('/dashboard/matters')

      // Safely handle Userpilot reload
      if (window.userpilot?.reload) {
        try {
          window.userpilot.reload()
        } catch (error) {
          console.warn('Failed to reload Userpilot:', error)
        }
      }
    }
  }
}

// Initialize the window navigation
initializeWindowNavigation()
